import { create } from 'zustand'

type UserInactivityState = {
  expireTime: number | null
  setExpireTime: (time: number) => void
}

export const useUserInactivityStore = create<UserInactivityState>((set) => ({
  expireTime: null,
  setExpireTime: (time) => set({ expireTime: time }),
}))
